export default __webpack_public_path__ + "static/7-system-notification-0984ce364afbde6a51563a38935c25ce.png";